import React, { useState, useRef } from 'react';
import Modal from '../../Atoms/Modal/Modal';
import fileIcon from '../../../assets/Imagess/file-icon-green.svg';
import uploadIcon from '../../../assets/Imagess/upload-icon.svg';
import styles from '../../Atoms/Modal/Modal.module.scss';
import Buttons from '../../Atoms/Buttons/Buttons';
import closeIcon from '../../../assets/Imagess/close2.svg';
import { isEmpty } from 'lodash';
import { useMutation } from 'react-query';
import { API_URL, securityHeaders } from '../../../Constants';
import axios from 'axios';
import { useToast } from '../Custom/CustomToaster/Toast';
import { toast } from 'react-toastify';

const UploadImageModal = ({ handleOnClose, refetch, id }) => {
  const fileInputRef = useRef(null);
  const customizedToast = useToast();
  const [images, setImages] = useState([]);

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setImages((prevImages) => [...prevImages, ...files]);
  };

  const handleUploadImageClick = () => {
    fileInputRef.current.click();
  };

  const uploadImage = useMutation({
    mutationFn: (fields) => {
      return axios.post(API_URL + `/api/News/MediaGalleryDetails`, fields, {
        headers: securityHeaders,
      });
    },
    onSuccess: (data) => {
      customizedToast.open('تم الرفع بنجاح');
      refetch();
    },
    onError: (error) => {
      toast.error(error?.message);
    },
  });

  const handleUploadImages = async () => {
    for (let i = 0; i < images.length; i++) {
      const formData = new FormData();
      formData.append('MediaGalleryId', id);
      formData.append('Image', images[i]);
      try {
        await uploadImage.mutate(formData);
        if (i + 1 === images.length) {
          refetch();
          handleOnClose();
        }
      } catch (error) {
        console.error('خطأ أثناء رفع الصورة:', error);
      }
    }
  };

  const handleRemoveImage = (index) => {
    setImages((prevImages) => prevImages.filter((_, i) => i !== index));
  };

  return (
    <Modal
      onClose={handleOnClose}
      width='30vw'
      closeWhite={false}
      title='رفع صورة'
    >
      <div className={styles['delete-container']}>
        <div
          className={styles['upload-container']}
          onClick={handleUploadImageClick}
        >
          <img src={uploadIcon} className={styles['upload-icon-modal']} />
          <div className={styles['text-row']}>
            <p className={styles['select-text']}>اختر وسائط للرفع</p>
            <p className={styles['size-text']}>الحجم الأقصى: 100 ميغابايت</p>
          </div>
        </div>
        <div className={styles['imagesToUpload-container']}>
          {!isEmpty(images) &&
            images.map((image, index) => (
              <div key={index} className={styles['uploaded-item-container']}>
                <div className={styles['file-name-container']}>
                  <img src={fileIcon} />
                  <p className={styles['file-name']}>{image?.name}</p>
                </div>
                <div
                  className={styles['remove-image-icon']}
                  onClick={() => handleRemoveImage(index)}
                >
                  <img src={closeIcon} />
                </div>
              </div>
            ))}
        </div>

        <Buttons
          text='رفع'
          color='#0DA06E'
          rounded={true}
          style={{ width: '100%', fontFamily: 'BukraBold' }}
          type='submit'
          handleOnClick={handleUploadImages}
        />
      </div>
      <input
        type='file'
        accept='image/*'
        className='form-control form-body-input'
        style={{ display: 'none' }}
        ref={fileInputRef}
        onChange={handleImageChange}
        multiple
        required
      />
    </Modal>
  );
};

export default UploadImageModal;
